import { DownForMaintenanceView } from 'components/DownForMaintenanceView';
import { PageWrapper } from 'components/PageWrapper';
import React, { FC } from 'react';
import { selectConsentStatus } from '../../consentSelectors';
import { useAppSelector } from '../../../../hooks';

const StatusView: FC = () => {
  const { status, message } = useAppSelector(selectConsentStatus);
  if (status === 'down-for-maintenance') {
    return (
      <PageWrapper>
        <DownForMaintenanceView message={message!} />
      </PageWrapper>
    );
  } else {
    return null;
  }
};

export default StatusView;
